import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks";

export default () => {
    const { query, response: { products } } = useAppState();
    const [ swatchData, setSwatchData ] = useState([]);
    const lastQueryRef = useRef(undefined);

    useEffect(() => {
        if(!products?.hits || products.hits?.length < 1) return;

        const fetchGroups = async (tags) => {
            try {
                const res = await fetch('https://api.nosto.com/v1/graphql', {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/graphql',
                        'Authorization': 'Basic ' + btoa(":" + "p27RLC8LfI8CweSZMDNykkCBgt6Bva16cV0rOfqFPLjT8yDyCi7F7B5nFTBgyxx5")
                    }),
                    mode: 'cors',
                    body: `
                    query {
                        products(limit: 500, filter: { tags1: ${JSON.stringify(tags)} }) { 
                            products {
                                productId
                                listPrice
                                price
                                name
                                brand
                                imageUrl
                                thumbUrl
                                availability
                                inventoryLevel
                                alternateImageUrls
                                url
                                tags1
                                skus {
                                    attributes { key, value },
                                    id,
                                    availability,
                                    inventoryLevel
                                }
                                attributes {
                                    key
                                    value
                                }
                            }
                        }
                    }
                `
                });
                const data = await res.json();
                return data;
            } catch (err) {
                return console.error(err);
            }
        };

        const isNewQuery = query?.query && query.query !== lastQueryRef?.current;
        if(isNewQuery) { 
            lastQueryRef.current = query.query;
        }

        // determine new product groups to query
        const groupsToFetch = [];
        const swatchDataToKeep = [];
        products.hits.forEach(product => {
            const groupTag = product?.tags1?.find(tag => tag.includes('STYLENAME:'));
            const groupInData = swatchData?.find(group => group.groupId === groupTag);
            if(groupTag && !groupInData && !groupsToFetch.includes(groupTag)) {
                groupsToFetch.push(groupTag);
            } else if (isNewQuery && groupInData) {
                swatchDataToKeep.push(groupInData);
            }
        });
        if(groupsToFetch?.length < 1) return // no NEW groups: skip query

        fetchGroups(groupsToFetch)
            .then(data => {
                const groupProducts = data?.data?.products?.products.filter(product => product.availability !== 'Invisible');
                if(!groupProducts || groupProducts?.length < 1) return;
                const updatedSwatchData = (isNewQuery) ? swatchDataToKeep : [...swatchData];
                groupsToFetch.forEach(groupTag => {
                    const swatchProducts = groupProducts.filter(product => !!product.tags1.includes(groupTag));
                    const swatchGroup = { groupId: groupTag, products: swatchProducts };          
                    updatedSwatchData.push(swatchGroup);
                });
                setSwatchData(updatedSwatchData);
            });
        }, [ products, query?.query ]);
    return {
        swatchData,
    }
}
